module.exports = __webpack_public_path__ + "img/bg_title_bottom.ed79f31a.png";